export default "__VITE_ASSET__cb603a78__"